import "../../IssuancePanel.css";

import { ActionButtons, Column, Modal, Row } from "../../../../widget";
import { useDeleteIssuancePanel } from "./useDeleteIssuanceModal";

interface DeleteIssuanceModalProps {
  onClose: () => void;
  show: boolean;
  rowVersion?: number;
  issuanceUuid?: string;
  handleRefresh: () => void;
}

export const DeleteIssuanceModal = ({
  onClose,
  show,
  rowVersion,
  issuanceUuid,
  handleRefresh,
}: DeleteIssuanceModalProps): JSX.Element => {
  const { handleDeleteIssuance, isHandleDeleteIssuanceLoading, showIssuanceTransactionWarning } =
    useDeleteIssuancePanel({
      onClose,
      rowVersion,
      issuanceUuid,
      handleRefresh,
    });
  return (
    <Modal show={show} title="Delete issuance?" onClose={onClose}>
      <form onSubmit={(e) => handleDeleteIssuance(e)}>
        <Row spacingV="l">
          <Column span={12} align="center" justify="center">
            {showIssuanceTransactionWarning ? (
              <>
                <p className="DeleteIssuanceMessage">
                  This issuance has related transactions and deleting it may invalidate these records.
                </p>
                <p className="DeleteIssuanceMessage">This action cannot be undone</p>
              </>
            ) : (
              <p className="DeleteIssuanceMessage">This action cannot be undone</p>
            )}
          </Column>
        </Row>
        <div className="DeleteIssuanceActions">
          <ActionButtons submitButtonLabel="Delete" onCancel={onClose} isLoading={isHandleDeleteIssuanceLoading} />
        </div>
      </form>
    </Modal>
  );
};
